"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _slateEditor = require("slate-editor");
var _boldPlugin = require("@slate-editor/bold-plugin");
var _italicPlugin = require("@slate-editor/italic-plugin");
var _underlinePlugin = require("@slate-editor/underline-plugin");
var _strikethroughPlugin = require("@slate-editor/strikethrough-plugin");
var _alignmentPlugin = require("@slate-editor/alignment-plugin");
var _linkPlugin = require("@slate-editor/link-plugin");
var _listPlugin = require("@slate-editor/list-plugin");
var _fontFamilyPlugin = require("@slate-editor/font-family-plugin");
var _fontSizePlugin = require("@slate-editor/font-size-plugin");
var _imagePlugin = require("@slate-editor/image-plugin");
var _colorPlugin = require("@slate-editor/color-plugin");
var _gridPlugin = require("@slate-editor/grid-plugin");
var _embedPlugin = require("@slate-editor/embed-plugin");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
if (require('exenv').canUseDOM) require('./index.scss');
const fontSizePluginOptions = {
  initialFontSize: 16
};
const plugins = [(0, _alignmentPlugin.AlignmentPlugin)(), (0, _boldPlugin.BoldPlugin)(), (0, _colorPlugin.ColorPlugin)(), (0, _embedPlugin.EmbedPlugin)(), (0, _fontFamilyPlugin.FontFamilyPlugin)(), (0, _fontSizePlugin.FontSizePlugin)(fontSizePluginOptions), (0, _gridPlugin.GridPlugin)(), (0, _imagePlugin.ImagePlugin)(), (0, _italicPlugin.ItalicPlugin)(), (0, _linkPlugin.LinkPlugin)(), (0, _listPlugin.ListPlugin)(), (0, _strikethroughPlugin.StrikethroughPlugin)(), (0, _underlinePlugin.UnderlinePlugin)()];
class EditorSlate extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialState: JSON.parse(props.content)
    };
  }
  render() {
    const _this$props = this.props,
      readOnly = _this$props.readOnly,
      contentStyles = _this$props.contentStyles;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "widgets--content-plugin"
    }, /*#__PURE__*/_react.default.createElement(_slateEditor.SlateEditor, {
      plugins: plugins,
      initialState: this.state.initialState,
      style: {
        color: '#fff'
      }
    }, /*#__PURE__*/_react.default.createElement(_slateEditor.SlateContent, {
      wrapperStyle: {
        position: 'relative',
        zIndex: 'inherit'
      },
      style: _objectSpread({
        minHeight: 150
      }, contentStyles),
      readOnly: readOnly
    })));
  }
}
var _default = exports.default = (0, _reactIntl.injectIntl)(EditorSlate);